import React, { useEffect, useState } from "react";
// import "./PacakageManagement.scss";
import './PackageManagement.scss' ;
import { ReactComponent as TotalProject } from "../../Assets/Images/Group 1171275921.svg";
import { ReactComponent as TotalTower } from "../../Assets/Images/Group 1171275923.svg";
import { ReactComponent as TotalRegistration } from "../../Assets/Images/Group 1171275949.svg";
import { ReactComponent as Totalhandover } from "../../Assets/Images/Icon.svg";
import { SvgIcon } from "@mui/material";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import DatePickers from "../../Components/DatePicker/DatePicker";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { packageManagementCard } from "../../Redux/Slicers/PackageManagement/PackageManagementCardSlice";
import ButtonField from "../../Components/Button/ButtonField";
import { Add, Cancel, Delete, Edit } from "@mui/icons-material";
import Dialog from "../../Components/Dialog/Dialog";
import MasterForm from "./PackageManagementForm";
import { IPackageCard } from "./IPacakageManagement";
import { FormikProps } from "formik";
import IconButtonField from "../../Components/Button/IconButtonField";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import { clearAddPackageState } from "../../Redux/Slicers/PackageManagement/AddPackageManagementSlicer";
import {
  clearUpdateableData,
  clearUpdatePackageState,
  PackageUpdateableData,
} from "../../Redux/Slicers/PackageManagement/UpdatePackageManagementSlicer";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { deletePackage } from "../../Redux/Slicers/PackageManagement/DeletePackageManagementSlice";

const Package = () => {
  const dispatch = useAppDispatch();
  const { data: packageManagementCards, isLoading } = useAppSelector(
    (state: any) => state.PackageManagementCard
  );
  const [open, setOpen] = useState<boolean>(false);
  const [formik, setFormik] = useState<FormikProps<IPackageCard>>();
  const { data: addPackage } = useAppSelector((state) => state.AddPackage);
  const { data: updatePackage, updateableDate } = useAppSelector(
    (state) => state.UpdatePackage
  );
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteableName, setDeleteableName] = useState<string>("");
  const [deleteableId, setDeleteableId] = useState<number>(0);
  const pathParts = window.location.pathname.split("/");
  const locationId = pathParts[pathParts.length - 1]; // last part of the path
  const { data: deletePackageData } = useAppSelector(
    (state) => state.DeletePackage
  );
  useEffect(() => {
    dispatch(packageManagementCard(locationId));
  }, [addPackage, updatePackage, deletePackageData]);

  const masterForm = (data: FormikProps<IPackageCard>) => {
    setFormik(data);
  };

  useEffect(() => {
    return () => {
      dispatch(clearAddPackageState());
      dispatch(clearUpdatePackageState());
      dispatch(clearUpdateableData());
    };
  }, []);
  return (
    <div className="package_container">
      <div className="package_header_container">
        <div className="package_headings_container">
          <p className="package_heading">Membership Package Management</p>
          <p
            className="package_sub_heading"
            style={{ textAlign: "right" }}>
            <ButtonField
              className="add_button"
              onClick={() => setOpen(true)}>
              <SvgIcon
                component={Add}
                inheritViewBox
              />
              Add New
            </ButtonField>
          </p>
        </div>
        <div className="package_header_cards_container">
          {packageManagementCards?.response?.data?.map(
            (e: any, index: number) => (
              <div
                key={index}
                className="package_card"
                style={{
                  background: "linear-gradient(135deg, #87ceeb, #32cd32)",
                  flexDirection: "row-reverse",
                }}>
                <Delete
                  className="action_icons"
                  sx={{
                    marginBottom: "auto",
                    cursor: "pointer",
                    marginLeft: "10px",
                    color: "#10720E",
                  }}
                  onClick={() => {
                    setDeleteOpen(true);
                    setDeleteableName(e.package_name ?? "");
                    setDeleteableId(e._id!);
                  }}
                />

                <Edit
                  className="action_icons"
                  sx={{
                    marginBottom: "auto",
                    cursor: "pointer",
                    color: "#10720E",
                  }}
                  onClick={() => {
                    console.log(e);

                    dispatch(PackageUpdateableData(e));
                    setOpen(true);
                  }}
                />
                {/* <div style={{flexDirection:"column"}}>  */}

                {/* </div> */}
                <div className="package_content_container">
                  <p className="content_title">Package: {index + 1}</p>
                  <p className="content_value">Name: {e.package_name}</p>
                  <p className="content_value">Price: {e.package_price}</p>
                  <p className="content_value">Days: {e.package_days}</p>
                  <p className="content_value">Type: {e.package_type}</p>
                  <p className="content_value">
                    Description: {e.package_description}
                  </p>
                  {e.working_hours && (
                    <div className="content_value">
                      <span>Working Time:</span>
                      <ul style={{ margin: 0, paddingLeft: 16 }}>
                        {Object.entries(e.working_hours).map(
                          ([day, time]: any, i: number) => (
                            <li key={i} style={{ whiteSpace: "nowrap" }}>
                              {day.charAt(0).toUpperCase() + day.slice(1)}:{" "}
                              {time.open
                                ? `Active (${time.start} - ${time.end})`
                                : "Deactive"}
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            )
          )}
        </div>
      </div>

      <Dialog
        open={open}
        dialogClassName="master_dialog"
        dialogTitleClassName="master_dialog_title"
        Dialog_Title={
          <>
            {updateableDate ? "Edit Package" : "Add New Package"}
            <IconButtonField onClick={() => setOpen(false)}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        Dialog_Content={<MasterForm masterForm={masterForm} />}
        dialogActionClassName="master_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={() => setOpen(false)}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => formik?.handleSubmit()}>
              {updateableDate ? "Update" : "Save"}
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        response={addPackage}
        parentDialog={setOpen}
      />
      <ResponseDialog
        response={updatePackage}
        parentDialog={setOpen}
      />

      <DeleteDialog
        deleteableName={deleteableName}
        open={deleteOpen}
        setOpen={setDeleteOpen}
        deleteFunction={() => dispatch(deletePackage(deleteableId))}
        response={deletePackageData}
      />
    </div>
  );
};

export default Package;
